module.exports = __webpack_public_path__ + "img/excellent.9f66ced8.svg";